module.exports = __webpack_public_path__ + "img/iptu-2025-m.45ab2cd1.jpg";